exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-layout[data-v-0e8b20a0] {\n  margin-top: 15px;\n}\n", ""]);

// exports
